module.exports = __webpack_public_path__ + "static/media/crazygames.78ff261c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/crazygames.jpg
// module id = 484
// module chunks = 0